export default (data) => {
  const result = data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if(data < 0)
    return `(${result.replace(/-/, '')})`

  return result
}
